import { render } from "./NotFound.vue?vue&type=template&id=90fc7810"
const script = {}

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__